import domready from 'domready';
import React from 'react';
import ReactDOM from 'react-dom';
import { createStore, compose, combineReducers } from 'redux';
import { install } from 'redux-loop';
import { connect } from 'react-redux';

import SignupPage from './components/SignupPage';
import TermsOfUseAcceptance from 'apps/termsOfUseAcceptance/components';

import loadTermsState from 'apps/termsOfUseAcceptance/lib/loadInitialState';
import { getReducer as getTermsReducer, Actions as termsActions } from 'apps/termsOfUseAcceptance/reducers';
const terms = getTermsReducer(loadTermsState(window.Raise.data.termsOfUseAcceptance));

import loadSignupState from './components/SignupPage/lib/loadInitialState';
import signupReducer from './components/SignupPage/reducers';
import signupActions from './components/SignupPage/actions';
const signup = signupReducer(loadSignupState(window.Raise.data.signup));

const reducer = combineReducers({ terms, signup });
const Actions = { terms: termsActions, signup: signupActions };

// leave commented out for easy static markup creation
// import { renderToStaticMarkup } from 'react-dom/server';

domready(() => {
  const store = createStore(
    reducer,
    undefined,
    compose(
      install(),
      (typeof window !== 'undefined' && window.devToolsExtension) ? window.devToolsExtension() : (x) => x
    )
  );

  const data = {
    signupUrl: window.Raise.data.signup.signupUrl,
    loginPath: window.Raise.data.signup.loginPath,
    isReferral: window.Raise.data.signup.isReferral,
  };
  const $signupEl = document.getElementById('react-signup-container');
  const signupConnector = (s) => ({ model: s.signup.toJS(), terms: s.terms.toJS(), data, Actions });
  const SignupPageContainer = connect(signupConnector)(SignupPage);

  const $termsEl = document.getElementById('react-terms-of-use-acceptance-container');
  const termsConnector = (s) => s.terms.toJS();
  const TermsOfUseAcceptanceContainer = connect(termsConnector)(TermsOfUseAcceptance);

  // console.warn('SignupPage');
  // console.log(renderToStaticMarkup(<SignupPageContainer store={store} />));

  if ($signupEl) ReactDOM.render(<SignupPageContainer store={store} />, $signupEl);
  if ($termsEl) ReactDOM.render(<TermsOfUseAcceptanceContainer store={store} />, $termsEl);
});
